/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { AddedDevices } from '../../interfaces/financials/added-devices-response.interface';

@Injectable({
  providedIn: 'root',
})
export class FinancialsService {
  constructor(private http: HttpClient) {}

  getAddedDevicesByGroupId(groupId: string): Observable<any[]> {
    return this.http.get<any>(
      `${getRestEndpoint()}/payments/devices-by-groupId/${groupId}`,
    );
  }
  getReceiptDetails(referenceId: string, isDebit: boolean): Observable<string> {
    return this.http.get<string>(
      `${getRestEndpoint()}/payments/GetCreditSale/${referenceId}/${isDebit}`,
    );
  }

  getReceiptDetailsACH(referenceId: string): Observable<string> {
    return this.http.get<string>(
      `${getRestEndpoint()}/payments/GetACHSale/${referenceId}`,
    );
  }

  addDevice(addedDevices: AddedDevices): Observable<any> {
    return this.http
      .post<any>(`${getRestEndpoint()}/payments/add-device`, addedDevices)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  setGPCustomer(
    consumerId: string,
    clientId: string,
    ScGroupId: string,
  ): Observable<any> {
    const json = { consumerId, clientId, ScGroupId };
    return this.http
      .post<any>(`${getRestEndpoint()}/payments/SetGPCustomer`, json)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
  setGPStatement(
    consumerId: string,
    clientId: string,
    ScGroupId: string,
    gpcResult: any,
  ): Observable<any> {
    const req = { consumerId, clientId, ScGroupId, gpcResult };
    return this.http
      .post<any>(`${getRestEndpoint()}/payments/setGPStatement`, req)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
